import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import { AppContext } from "../../utils/context/app.context.js";
import FormComponent from '../../utils/components/form.component';
import systemService from '../../services/system.service.js';

export default function Remember() {
    const { t } = useTranslation();
    const appContext = useContext(AppContext);
    const navigate = useNavigate();

    function onSubmit(form) {
        toast.info(t('actions.procesing'));
        systemService.app_remember(form)
            .then(res => {
                if (res.data) {
                    toast.dismiss();
                    toast.success(t('actions.sendMail'));
                   
                }
            })
            .catch(error => appContext.errorHandler(error, toast, t))
    }
    
    const FORM = () => [
        {
            title: t('remember.subtitle'),
            inputs: [
                [
                    { id: "email", title: t('remember.email'), placeholder: t('remember.email'), icon: "envelope", required: true, pattern: appContext.emailPattern},

                ],
            ]
        },
    ]

    return (

        <div className="app-container">
            <div className="app-overlay">
                <div className="row m-0 p-o">
                    <div className="container">
                        <div className="row justify-content-center m-5">
                            <div className="col-md-6 col-sm-12">

                                <ToastContainer theme="colored" />
                                <h2>{t("remember.title")}</h2>

                                <FormComponent
                                    actions={{
                                        primary: { icon: "send-message", text: t('actions.send') },
                                        secondary: { icon: "arrow-left", text: t('actions.back') }
                                    }}
                                    onSecondary={() => navigate("/login")}
                                    onSubmit={(data) => onSubmit(data)}
                                    groups={FORM()}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
